import React from 'react';
import {
  useColorModeValue } from "./ui/color-mode";
import { Badge,
  Box,
  Button,
  Flex,
  HStack,
  Text,
  VStack,
} from '@chakra-ui/react';
import { FaList, FaTrash } from 'react-icons/fa';

export default function BandaRepertorioCarpetaFicha({
  carpeta,
  onGestionarObras,
  onEliminarTodasObras,
  carpetasMutating,
}) {
  const muted = useColorModeValue('gray.600', 'gray.400');
  const cardBorder = useColorModeValue('gray.200', 'gray.600');
  const panelBg = useColorModeValue('purple.50', 'rgba(88, 28, 135, 0.18)');

  const filas = Array.isArray(carpeta?.obras) ? carpeta.obras : [];
  const totalObras = filas.length;

  return (
    <VStack align="stretch" gap={5}>
      {carpeta.descripcion ? (
        <Box borderWidth="1px" borderColor={cardBorder} rounded="xl" p={4}>
          <Text fontWeight="700" fontSize="sm" mb={2}>
            Descripción
          </Text>
          <Text fontSize="sm" color={muted} whiteSpace="pre-wrap">
            {carpeta.descripcion}
          </Text>
        </Box>
      ) : (
        <Text fontSize="sm" color={muted}>
          Sin descripción.
        </Text>
      )}

      <Box px={4} py={3} rounded="xl" borderWidth="1px" borderColor={cardBorder} bg={panelBg}>
        <Text fontSize="xs" color={muted} fontWeight="600" textTransform="uppercase" letterSpacing="wide">
          Obras en la carpeta
        </Text>
        <Text fontSize="2xl" fontWeight="800" mt={1}>
          {totalObras}
        </Text>
        <Text fontSize="xs" color={muted} mt={1}>
          El orden del listado es el de interpretación en actuaciones o descargas por carpeta.
        </Text>
      </Box>

      <HStack gap={2} flexWrap="wrap">
        <Button size="sm" colorPalette="purple" onClick={onGestionarObras}><FaList />Gestionar obras
                  </Button>
        <Button
          size="sm"
          variant="outline"
          colorPalette="red"
          onClick={onEliminarTodasObras}
          disabled={totalObras === 0}
          loading={carpetasMutating}><FaTrash />Eliminar todas las obras
                  </Button>
      </HStack>

      <Box>
        <Text fontWeight="700" fontSize="sm" mb={3}>
          Orden del programa ({totalObras})
        </Text>
        {totalObras === 0 ? (
          <Text fontSize="sm" color={muted}>
            Esta carpeta no tiene obras. Usa «Gestionar obras» para añadirlas.
          </Text>
        ) : (
          <VStack align="stretch" gap={2}>
            {filas.map((row, idx) => {
              const o = row.obra;
              if (!o) return null;
              return (
                <Flex
                  key={row.id || o.id}
                  align="flex-start"
                  gap={3}
                  p={3}
                  rounded="lg"
                  borderWidth="1px"
                  borderColor={cardBorder}
                >
                  <Flex
                    align="center"
                    justify="center"
                    w={7}
                    h={7}
                    rounded="md"
                    bg={panelBg}
                    fontWeight="800"
                    fontSize="sm"
                    flexShrink={0}
                  >
                    {idx + 1}
                  </Flex>
                  <Box minW={0} flex={1}>
                    <Text fontWeight="600" fontSize="sm" lineClamp={2}>
                      {o.titulo}
                    </Text>
                    {o.autor ? (
                      <Text fontSize="xs" color={muted} lineClamp={1} mt={0.5}>
                        {o.autor}
                      </Text>
                    ) : null}
                    <HStack gap={1} mt={1.5} flexWrap="wrap">
                      {o.genero?.nombre ? (
                        <Badge fontSize="0.65rem" variant="outline" colorPalette="purple">
                          {o.genero.nombre}
                        </Badge>
                      ) : null}
                    </HStack>
                  </Box>
                </Flex>
              );
            })}
          </VStack>
        )}
      </Box>
    </VStack>
  );
}
